import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

import TEXT from '../../../text';
import * as FILTER_HELPER from '../../../utils/filterHelperFunctions';

class WorkExperienceFilter extends PureComponent {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
  }

  /**
   * onChange method for the WorkExperienceFilter component, calls the onFilterChange function
   * @param  {array} range array of values of the two handlers of slider
   */
  onChange(arrayOfSelected) {
    this.props.onFilterChange(
      'workExperience',
      arrayOfSelected,
      FILTER_HELPER.filterFunctions.workExperience
    );
  }

  handleChange = name => event => {
    const arrayOfSelected = this.props.workExperience;
    if (event.target.checked) {
      arrayOfSelected.push(name);
    } else {
      const index = arrayOfSelected.indexOf(name);
      arrayOfSelected.splice(index, 1);
    }

    this.onChange(arrayOfSelected);
  };

  render() {
    const headline = `${TEXT.filter.jobFilter.workExperience.headline}`;
    const countedJobParameters = this.props.countedJobParameters;
    const labels = TEXT.filter.jobFilter.workExperience.labels;
    const checkboxLabels = {
      '0-1': labels.label1,
      '1-2': labels.label2,
      '2-5': labels.label3,
      '5-10': labels.label4,
      '10-100': labels.label5
    };

    const checkboxValues = this.props.stickyFilter
      ? this.props.workExperience
      : countedJobParameters.workExperience;

    return (
      <div>
        {checkboxValues &&
          checkboxValues.length > 0 && (
            <div className="col-12 pb-5 checkFilterBox">
              <FormControl component="fieldset" fullWidth>
                <FormLabel component="legend">{headline}</FormLabel>
                <FormGroup>
                  {checkboxValues &&
                    checkboxValues.map(rawElement => {
                      let element = rawElement;
                      let elementCount;
                      let elementCountDOM = '';
                      if (rawElement.key) {
                        element = rawElement.key;
                        elementCount = rawElement.count;
                        elementCountDOM = `(${elementCount})`;
                      }
                      return (
                        <FormControlLabel
                          className="checkFilterLabel"
                          key={element}
                          control={
                            <Checkbox
                              className="chkBox_"
                              checked={this.props.workExperience.includes(
                                element
                              )}
                              onChange={this.handleChange(element)}
                              value={element}
                            />
                          }
                          label={`${
                            checkboxLabels[element]
                          } ${elementCountDOM}`}
                        />
                      );
                    })}
                </FormGroup>
              </FormControl>
            </div>
          )}
      </div>
    );
  }
}
WorkExperienceFilter.defaultProps = {
  countedJobParameters: {},
  stickyFilter: false
};
WorkExperienceFilter.propTypes = {
  onFilterChange: PropTypes.func.isRequired,
  workExperience: PropTypes.arrayOf(PropTypes.string).isRequired,
  // object is allowed in this case, as the object can have any shape
  countedJobParameters: PropTypes.object, // eslint-disable-line
  stickyFilter: PropTypes.bool
};
export default WorkExperienceFilter;
